export enum EUploadState {
    INITIAL = 'Initial',
    EDITED = 'Edited',
    READY = 'Ready',
    UPLOADING = 'Uploading',
    FINISHED = 'Finished',
    FAILED = 'Failed',
    DELETED = 'Deleted'
}
